export const isImgUrl = async (url: string) => {
  const img = new Image();
  img.src = url;

  return new Promise((resolve) => {
    img.onerror = () => resolve(false);
    img.onload = (res) => {
      console.log('res:', res);
      resolve(true);
    };
  });
};

export const hasImageExtension = async (url: any) => {
  const imageExtensions = /\.(jpeg|jpg|png|gif|bmp)$/i;
  const svgExtension = /\.svg$/i;
  return imageExtensions.test(url) && !svgExtension.test(url);
};

// Function to download and convert image to base64
export const downloadAndConvertToBase64 = async (url: string) => {
  return new Promise<string>((resolve, reject) => {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        console.log(blob);

        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result as string;
          resolve(base64data);
        };
        reader.onerror = () => {
          reject('Error reading image file.');
        };
        reader.readAsDataURL(blob);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
